import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import heroImage from "../assets/loanInMinutes/Big.png";
import heroImageMobile from "../assets/loanInMinutes/Hero_2.png";
import { AboutUsSection } from "./AboutUs";
import { LoanCalculatorSection } from "./LoanCalculator";
import { WhyChooseUsSection } from "./WhyChooseUs";
import { EligibilityCriteriaSection } from "./EligibilityCriteria";
import { TestimonialsSection } from "./Testimonials";
import { SecurityNoticeSection } from "./SecurityNotice";
import { HowItWorksSection } from "./HowItWorks";
import { ApplicationJourneySection } from "./ApplicationJourney";
import { FaqSection } from "./Faq";
import { OfficeLocationSection } from "./OfficeLocation";
import { APPLY_NOW_PATH } from "../utils/appLinks";
import Footer from "./Footer";

const stats = [
  { value: "4.8 / 5", label: "User Rating" },
  { value: "50,000+", label: "Happy Users" },
  { value: "₹100 Cr+", label: "Loan Disbursed" },
  { value: "100%", label: "Digital" },
];

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }, [hash]);

  return (
    <div className="bg-white">

      <Navbar />

      {/* Hero */}
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row min-h-screen relative">

        {/* Text content panel */}
        <div className="flex flex-col items-center lg:items-start justify-center px-6 lg:px-8 pt-28 pb-10 lg:py-16 bg-white w-full lg:w-1/2 text-center lg:text-left">
          <h1 className="text-4xl sm:text-5xl xl:text-6xl font-black leading-tight mb-6 tracking-tight">
            <span className="text-[#040404]">Get A </span>
            <span className="text-[#CC1A1A]">Loan</span>
            <br />
            <span className="text-[#0a0a0b]">Within </span>
            <span className="text-[#CC1A1A]">Seconds</span>
          </h1>

          <p className="text-gray-500 text-lg leading-relaxed max-w-md mb-10">
            Apply online, get personalised offers, and complete your application
            without paperwork or branch visits. Money in your account, fast.
          </p>

          {/* Buttons — stacked full-width on mobile, inline on desktop */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10 lg:mb-16">
            <a
              href={APPLY_NOW_PATH}
              className="w-[80%] mx-auto sm:mx-0 sm:w-auto px-8 py-3.5 bg-[#CC1A1A] text-white text-sm tracking-widest uppercase hover:bg-red-800 transition-colors rounded text-center"
            >
              APPLY ONLINE
            </a>
            <a
              href="#loan-calculator"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById("loan-calculator");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="w-[80%] mx-auto sm:mx-0 sm:w-auto px-8 py-3.5 border border-[#CC1A1A] text-[#CC1A1A] text-sm tracking-widest uppercase hover:bg-red-50 transition-colors rounded text-center cursor-pointer"
            >
              LOAN CALCULATOR
            </a>
          </div>

          {/* Stats — desktop only (mobile shows below image) */}
          <div className="hidden lg:flex flex-wrap gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="text-[#CC1A1A] font-medium text-xl">{stat.value}</span>
                <span className="text-gray-500 text-sm mt-0.5">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Image panel — visible on all screens */}
        <div className="w-full lg:w-1/2 min-h-[420px] lg:min-h-0">
          {/* Mobile image */}
          <img
            src={heroImageMobile}
            alt="Happy family with fast loan"
            className="lg:hidden absolute bottom-10 left-1/2 -translate-x-1/2 h-[92%] w-full object-contain object-bottom scale-[1.12] origin-bottom pointer-events-none"
          />
          {/* Desktop image */}
          {/* <img
            src={heroImage}
            alt="Happy family with fast loan"
            className="hidden lg:block absolute bottom-13 2xl:bottom-52 h-[92%] w-full object-contain object-bottom scale-[1.35] origin-bottom"
          /> */}

           <img
            src={heroImage}
            alt="Happy family with fast loan"
            className="hidden lg:block absolute bottom-[8vh] -right-[19vw] 2xl:-right-[22vw] h-[80%] w-full object-contain object-bottom scale-[1.15] origin-bottom pointer-events-none"
          />
        </div>

        {/* Stats — mobile only, shown below image */}
        <div className="flex lg:hidden justify-between px-6 pb-4 sm:py-8 bg-white border-gray-100">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <span className="text-[#CC1A1A] font-medium text-lg">{stat.value}</span>
              <span className="text-gray-500 text-xs mt-0.5 text-center">{stat.label}</span>
            </div>
          ))}
        </div>

      </div>

      <div id="how-it-works" className="scroll-mt-[73px]"><HowItWorksSection /></div>
      <div id="application-journey" className="scroll-mt-[73px]"><ApplicationJourneySection /></div>
      <div id="about-us" className="scroll-mt-[73px]"><AboutUsSection /></div>
      <div id="loan-calculator" className="scroll-mt-[73px]"><LoanCalculatorSection /></div>
      <div id="why-choose-us" className="scroll-mt-[73px]"><WhyChooseUsSection /></div>
      <div id="eligibility" className="scroll-mt-[73px]"><EligibilityCriteriaSection /></div>
      <div id="testimonials" className="scroll-mt-[73px]"><TestimonialsSection /></div>
      <div id="security" className="scroll-mt-[73px]"><SecurityNoticeSection /></div>
      <div id="faq" className="scroll-mt-[73px]"><FaqSection /></div>
      <div id="office" className="scroll-mt-[73px]"><OfficeLocationSection /></div>
      <Footer />
    </div>
  );
};

export default Home;
